<template>
  <div class="wrapper">
    <AppForm label="目標">
      <v-layout>
        <v-switch
          v-show="!isCpcMenu"
          v-model="enableOptimization"
          :disabled="keepGoalOn"
          :false-value="false"
          :true-value="true"
          label="目標を設定する"
        />
      </v-layout>
      <v-layout v-if="enableOptimization">
        <v-flex xs2>
          <v-select
            v-model="campaign.goalType"
            :disabled="isCpcMenu"
            :items="types"
            @change="resetGoalValue"
            class="mr-2"
          />
        </v-flex>
        <v-flex xs3>
          <v-text-field
            v-if="isCpc"
            v-model.number="goalValue"
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            :disabled="isCpcMenu"
            :rules="cpcRules"
            type="number"
          >
            <template v-slot:prepend>
              <span class="yen">¥</span>
            </template>
          </v-text-field>
          <v-text-field
            v-else-if="isCtr"
            v-model="displayGoalValue"
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            @blur="formatCtrGoalValue"
            :rules="ctrRules"
            type="text"
          >
            <template v-slot:append>
              %
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="
          campaign.goalValue >= 0.005 &&
            campaign.goalType === 'ctr' &&
            campaign.enableOptimization
        "
        row
      >
        <v-flex shrink>
          <v-icon class="yellow--text text--darken-1">warning</v-icon>
        </v-flex>
        <v-flex>
          <p :style="{ color: 'red', paddingLeft: '8px', margin: 0 }">
            目標CTRの設定の値が高い場合、配信量の減少もしくは配信停止の恐れがあります。<br />
            0.5%未満の設定を推奨します。
          </p>
        </v-flex>
      </v-layout>
    </AppForm>
  </div>
</template>

<script>
import { OptimizationRepository } from '@/models/Optimization'
export default {
  name: 'CampaignModalPageBudgetGoal',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayGoalValue:
        this.form.campaign.goalType === 'ctr'
          ? this.formatToFixed(this.form.campaign.goalValue * 100)
          : this.form.campaign.goalValue,
    }
  },
  computed: {
    keepGoalOn() {
      if (this.menu.unitType === 'cpm') return false
      if (this.menu.unitType === 'cost plus margin') return false
      if (this.menu.unitType === 'cpcv') return true
      if (this.form.campaign.enableOptimization) return true
      return false
    },
    campaign() {
      return this.form.campaign
    },
    goalValue: {
      get() {
        return this.menu.unitType === 'cpc'
          ? this.menu.grossPrice
          : this.campaign.goalValue
      },
      set(goalValue) {
        this.campaign.goalValue = goalValue
      },
    },
    menu() {
      return this.campaign.menu
    },
    enableOptimization: {
      get() {
        return this.campaign.enableOptimization
      },
      async set(bool) {
        this.campaign.updateEnableOptimization(bool)
        if (bool) {
          this.campaign.goalType = 'cpc'
          await this.resetGoalValue()
        }
        const optimizationGoalObject = await this.getOptimizationGoal()
        this.campaign.goalValue = optimizationGoalObject.goalValue
      },
    },
    types() {
      return [
        { value: 'cpc', text: 'CPC' },
        { value: 'ctr', text: 'CTR' },
      ]
    },
    isCpcMenu() {
      return this.menu.unitType === 'cpc'
    },
    isCpc() {
      return this.campaign.goalType === 'cpc'
    },
    isCtr() {
      return this.campaign.goalType === 'ctr'
    },
    cpcRules() {
      return [value => value > 0 || '1以上の値を入力してください']
    },
    ctrRules() {
      return [
        value =>
          (value >= 0.01 && value <= 100) ||
          '0.01 - 100%の間で値を入力してください。',
      ]
    },
  },
  watch: {
    displayGoalValue: {
      immediate: true,
      handler(newValue) {
        if (this.isCtr) {
          this.campaign.goalValue = parseFloat(newValue) / 100
        }
      },
    },
  },
  methods: {
    async getOptimizationGoal() {
      const insertionOrderId = this.form.insertionOrderId
      const menuId = this.campaign.menuId
      const goalType = 'cpc'
      const optimizationGoal = await OptimizationRepository.getOptimizationGoal(
        insertionOrderId,
        menuId,
        goalType,
      )
      return optimizationGoal
    },
    async resetGoalValue() {
      if (this.campaign.goalType === 'cpc') {
        const cpcOptimizationGoal = await this.getOptimizationGoal()
        this.campaign.goalValue = cpcOptimizationGoal.goalValue
        this.displayGoalValue = cpcOptimizationGoal.goalValue
      }
      if (this.campaign.goalType === 'ctr') {
        this.campaign.goalValue = 0.002
        this.displayGoalValue = this.formatToFixed(0.2)
      }
    },
    formatCtrGoalValue() {
      if (this.isCtr) {
        this.displayGoalValue = this.formatToFixed(this.displayGoalValue)
        this.campaign.goalValue = parseFloat(this.displayGoalValue) / 100
      }
    },
    formatToFixed(value) {
      const displayValue = parseFloat(value).toFixed(2)
      if (!value || displayValue === 'NaN') return '0.20'
      return displayValue
    },
  },
}
</script>

<style>
.wrapper {
  width: 100%;
}
.yen {
  padding: 5px 5px 5px 15px;
}
.disabled-select {
  /*
    20190815時点で、CPCとCTRの選択は一旦できなくていい。
    CPCのみ。
  */
  pointer-events: none;
}
</style>
